var _mask, _path, _path2, _path3, _mask2, _path4, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSettingWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_436_46641",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35294 3.37012C6.35294 2.81783 6.80065 2.37012 7.35294 2.37012H16.6471C17.1993 2.37012 17.6471 2.81783 17.6471 3.37012V7.82931C17.6471 10.5907 15.4085 12.8293 12.6471 12.8293H11.3529C8.59151 12.8293 6.35294 10.5907 6.35294 7.82931V3.37012Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35294 3.37012C6.35294 2.81783 6.80065 2.37012 7.35294 2.37012H16.6471C17.1993 2.37012 17.6471 2.81783 17.6471 3.37012V7.82931C17.6471 10.5907 15.4085 12.8293 12.6471 12.8293H11.3529C8.59151 12.8293 6.35294 10.5907 6.35294 7.82931V3.37012Z",
    stroke: "#2E2E30",
    strokeWidth: 3.328,
    mask: "url(#path-1-inside-1_436_46641)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8235 7.58857C14.8235 8.92736 13.7174 10.0127 12.353 10.0127H11.6471C10.2826 10.0127 9.17648 8.92736 9.17648 7.58857C9.17648 6.99112 14.8235 7.0442 14.8235 7.58857Z",
    fill: "#2E2E30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8235 18.0067C14.8235 18.4504 14.4639 18.8101 14.0202 18.8101H9.97979C9.53612 18.8101 9.17646 18.4504 9.17646 18.0067V16.8136C9.17646 15.2542 10.4406 13.9901 12 13.9901C13.5594 13.9901 14.8235 15.2542 14.8235 16.8136V18.0067Z",
    fill: "#2E2E30"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_436_46641",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6471 20.6284C17.6471 21.1807 17.1993 21.6284 16.6471 21.6284H7.35295C6.80066 21.6284 6.35295 21.1807 6.35295 20.6284V16.1692C6.35295 13.4078 8.59152 11.1692 11.3529 11.1692H12.6471C15.4085 11.1692 17.6471 13.4078 17.6471 16.1692V20.6284Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6471 20.6284C17.6471 21.1807 17.1993 21.6284 16.6471 21.6284H7.35295C6.80066 21.6284 6.35295 21.1807 6.35295 20.6284V16.1692C6.35295 13.4078 8.59152 11.1692 11.3529 11.1692H12.6471C15.4085 11.1692 17.6471 13.4078 17.6471 16.1692V20.6284Z",
    stroke: "#2E2E30",
    strokeWidth: 3.328,
    mask: "url(#path-4-inside-2_436_46641)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2.37012,
    width: 16,
    height: 1.66,
    rx: 0.83,
    fill: "#2E2E30"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 19.9702,
    width: 16,
    height: 1.66,
    rx: 0.83,
    fill: "#2E2E30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSettingWaiting);
export default __webpack_public_path__ + "static/media/ic_setting_waiting.e2e75f5cd5d0c43cd2c93655ef1a7242.svg";
export { ForwardRef as ReactComponent };